module.exports = __webpack_public_path__ + "assets/logo-black@2x.e0ea6c7e.png";